module.exports = __webpack_public_path__ + "img/syllabus-title-xl.6386d1af.png";